import { render, staticRenderFns } from "./supplyList.vue?vue&type=template&id=60ddae56&scoped=true&"
import script from "./supplyList.vue?vue&type=script&lang=js&"
export * from "./supplyList.vue?vue&type=script&lang=js&"
import style0 from "./supplyList.vue?vue&type=style&index=0&id=60ddae56&scoped=true&lang=css&"
import style1 from "./supplyList.vue?vue&type=style&index=1&id=60ddae56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddae56",
  null
  
)

export default component.exports